export function formattedMoneyWithDecimals(val, culture) {
  if (parseFloat(val) < 0) {
    return "(" + val.toLocaleString(culture, { style: "currency", currency: "USD" }).replaceAll("US", "").replaceAll("-", "") + ")";
  }
  else {
    return val.toLocaleString(culture, { style: "currency", currency: "USD" }).replace(/US/g, "");
  }
}